import { WEBUILogs } from "../logging";

export default function typeOfOperand(operand) {
    //undefined and null operands
    if (typeof operand === "undefined" || operand === null || !operand.constructor)
        return "undefined";

    //ie issue - file constructor name is not supported
    if (!operand.constructor.name) {
        WEBUILogs.log(operand);
        return {}.toString
            .call(operand)
            .match(/\s([a-zA-Z]+)/)[1]
            .toLowerCase();
    }
    //possible return values of standard built-in objects:
    //function, symbol, object, array, date, file, regexp, error, map, set....
    return operand.constructor.name.toLowerCase();
}
